import Router from 'vue-router';
import FileUploadView from './views/FileUploadView';
import RemoteUrlView from './views/RemoteUrlView';
import NoUploadView from './views/NoUploadView';
import AIGenerationView from "./views/AIGenerationView.vue";

const ROUTES = [
    {
        path: '/file-upload',
        name: 'file-upload',
        component: FileUploadView,
    },
    {
        path: '/remote-url',
        name: 'remote-url',
        component: RemoteUrlView,
    },
    {
        path: '/no-upload',
        name: 'no-upload',
        component: NoUploadView,
    },
    {
        path: '/aigeneration',
        name: 'aigeneration',
        component: AIGenerationView,
    },
];

const uploadBoxRouter = new Router({
    mode: 'abstract',
    routes: ROUTES,
});

export {uploadBoxRouter};
export {ROUTES};
